export const API_URL = {
  GET_XRATES_LIST: '/xrate/get',
};
